import React from "react";
import { GetMoneyValue } from "../../../../../Api/ApiCommon";
import { PayInfoDetailProps } from "../PayInfoDetail";
import {
  PayDetailItem,
  PayDetailItemChildText,
  PayDetailItemGrayText,
  PayDetailItemText,
} from "./PartyFeePay";

interface MembersFee {
  uid: number;
  val: number;
  comm: number;
}

export default function PartyFeeSave({ data }: PayInfoDetailProps) {
  const exitDepositTotal = data?.log?.exit_deposit?.reduce(
    (sum, currValue) => sum + currValue.val,
    0
  );

  return (
    <>
      {/* label */}
      <PayDetailItem>
        <PayDetailItemText>파티 요금</PayDetailItemText>

        {data?.log?.members?.map((m: MembersFee, index: number) => (
          <div key={index} style={{ paddingLeft: 20 }}>
            {/* 파티원  */}
            <PayDetailItemText>파티원_{m?.uid}</PayDetailItemText>

            <>
              {/* 파티 분담금 */}
              <PayDetailItemChildText>파티 분담금</PayDetailItemChildText>

              {/* 링키드 수수료 */}
              <PayDetailItemChildText>링키드 수수료</PayDetailItemChildText>
            </>
          </div>
        ))}

        {data?.log?.exit_deposit?.length > 0 && (
          <PayDetailItemText>중도 탈퇴 보상금</PayDetailItemText>
        )}

        {data?.log?.exit_deposit?.map((m, index: number) => (
          <div key={index} style={{ paddingLeft: 20 }}>
            {/* 파티원  */}
            <PayDetailItemText>파티원_{m?.uid}</PayDetailItemText>
          </div>
        ))}

        <PayDetailItemText>쿠폰 혜택</PayDetailItemText>
        <PayDetailItemText>링키드 포인트 혜택</PayDetailItemText>
      </PayDetailItem>

      {/* value */}
      <PayDetailItem>
        {/* 파티 요금 */}
        <PayDetailItemText>
          {GetMoneyValue(
            data?.log?.amount -
              (data?.log?.coupon ?? 0) -
              (data?.log?.point ?? 0)
          )}
        </PayDetailItemText>

        {data?.log?.members?.map((m: MembersFee, index: number) => (
          <div key={index}>
            {/* 파티원  */}
            <PayDetailItemText>{GetMoneyValue(m?.val)}</PayDetailItemText>

            <>
              {/* 파티 분담금 */}
              <PayDetailItemGrayText>
                {GetMoneyValue(m?.val + (m?.comm ?? 0))}
              </PayDetailItemGrayText>

              {/* 링키드 수수료 */}
              <PayDetailItemGrayText>
                -{GetMoneyValue(m?.comm ?? 0)}
              </PayDetailItemGrayText>
            </>
          </div>
        ))}

        {/* 중도 탈퇴 보상금 */}
        {data?.log?.exit_deposit?.length > 0 && (
          <PayDetailItemText>
            {GetMoneyValue(exitDepositTotal)}
          </PayDetailItemText>
        )}

        {data?.log?.exit_deposit?.map((m, index: number) => (
          <div key={index}>
            {/* 파티원  */}
            <PayDetailItemText>{GetMoneyValue(m?.val)}</PayDetailItemText>
          </div>
        ))}

        {/* 쿠폰 혜택 */}
        <PayDetailItemText>
          {GetMoneyValue(data?.log?.coupon ?? 0)}
        </PayDetailItemText>

        {/* 링키드 포인트 혜택 */}
        <PayDetailItemText>
          {GetMoneyValue(data?.log?.point ?? 0)}
        </PayDetailItemText>
      </PayDetailItem>
    </>
  );
}
